import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";

import { tableColumn } from "utils";
import { TableList, ActionButton, OnOff } from 'components/common';


const SeoTemplateCollectionPhotoList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, seoTemplateCollectionPhoto }) => {
  const defaultColumnList = ['id', 'tpl_path', 'tpl_alt', 'is_active', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const [itemIdForUpdate, setItemIdForUpdate] = useState(null);
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    tpl_path: tableColumn('Путь', 'tpl_path', {
      sorter: true,
    }),
    tpl_alt: tableColumn('Тайтл', 'tpl_alt', {
      sorter: true,
    }),
    is_active: tableColumn('Активно', 'is_active', {
      sorter: false,
      width: 150,
      render: (val, item) => (
        <OnOff
          item={item}
          updateItemId={itemIdForUpdate}
          param="is_active"
          updateStatus={seoTemplateCollectionPhoto.updateStatus}
          preventLoadDetail={true}
          onChange={data => {
            setItemIdForUpdate(data.id);
            actions.seoTemplateCollectionPhoto.update(data);
          }}
        />
      ),
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton
          detail={item}
          modelActions={actions.seoTemplateCollectionPhoto}
          actions={[{ name: 'edit' }, { name: 'delete' }]}
          buttonActions={[{ name: 'copy', size: 'small' }]}
        />
      ),
    }),
  };

  const onLoad = useCallback(({ query, activeFilter }) => {
    if (activeFilter === undefined) {
      activeFilter = seoTemplateCollectionPhoto.filter.activeFilter
    }
    actions.seoTemplateCollectionPhoto.listLoad({ 
      query, activeFilter, locationChange: true, locationState: router.location.state
    });
  }, [seoTemplateCollectionPhoto, actions, router.location.state]);

  return (
    <TableList
      location={router.location}
      model={seoTemplateCollectionPhoto}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}
    />
  );
};

const mapState = state => ({
  router: state.router,
  seoTemplateCollectionPhoto: state.seoTemplateCollectionPhoto,
});

const mapDispatch = dispatch => ({
  actions: {
    seoTemplateCollectionPhoto: dispatch.seoTemplateCollectionPhoto,
  }
});

export default connect(mapState, mapDispatch)(SeoTemplateCollectionPhotoList);
